import React, { useEffect, useState } from 'react'
import { FaChevronCircleDown } from 'react-icons/fa'
import { FiUpload } from 'react-icons/fi'
import { RiAddFill } from 'react-icons/ri'
import { toast } from 'react-toastify'
import { SkyButton } from '../../Components/Buttons'
import CustomInput from '../../Components/Input/CustomInput'
import DatePicker from '../../Components/Input/DatePicker'
import {
  constructAddress,
  convertDOBToDate,
  extractNames,
} from '../../utils/extractNames'

const FleetDriverReg = ({
  driverDetails,
  setDriverDetails,
  errors,
  verifyAadhaar,
  verifyOTP,
}) => {
  const [driverForms, setDriverForms] = useState([0])
  const [driverformVisibility, setDriverFormVisibility] = useState([true])
  const [nextDriverFormNumber, setNextDriverFormNumber] = useState(1)
  const [verificationDetails, setVerificationDetails] = useState({
    otp: null,
    ref_id: null,
  })

  useEffect(() => {
    setDriverForms(driverDetails?.map((_, index) => index))
  }, [driverDetails])

  const handleVerifyAadhaar = async (index) => {
    if (driverDetails[index]?.otpCalled) {
      toast.warn('OTP already sent')
      return
    }
    const aadhaarNumber = driverDetails[index]?.aadharNumber
    await verifyAadhaar({ variables: { aadhaarNumber } })
      .then((res) => {
        const verifyAadhaarResponse = JSON.parse(res.data.verifyAadhaar)
        const status = verifyAadhaarResponse.status
        if (
          status === 'SUCCESS' ||
          verifyAadhaarResponse?.message == 'OTP sent successfully'
        ) {
          toast.success('OTP sent successfully')
          setVerificationDetails((prevState) => ({
            ...prevState,
            ref_id: verifyAadhaarResponse.ref_id,
          }))
          const updateddriverDetails = [...driverDetails]
          updateddriverDetails[index] = {
            ...updateddriverDetails[index],
            otpCalled: true,
            showVerify: true,
          }
          setDriverDetails(updateddriverDetails)
        }
      })
      .catch((error) => {
        toast.error(error.message)
      })
  }
  const handleVerifyOtp = async (index) => {
    if (driverDetails[index]?.verifyOtpCalled) {
      toast.warn('OTP has already been verified')
      return
    }
    await verifyOTP({
      variables: verificationDetails,
      fetchPolicy: 'network-only',
    })
      .then((res) => {
        console.log('res', res)
        if (res?.data) {
          const verifyOTPData = JSON.parse(res?.data?.verifyOTP)
          const status = verifyOTPData?.status
          if (status === 'VALID') {
            toast.success('OTP verified successfully')
            const data = verifyOTPData
            const { firstName, middleName, lastName } = extractNames(data?.name)
            const updateddriverDetails = [...driverDetails]
            updateddriverDetails[index] = {
              ...updateddriverDetails[index],
              firstName: firstName,
              middleName: middleName,
              lastName: lastName,
              birthDate: convertDOBToDate(data?.dob),
              permanentAddress: constructAddress(data),
              imageLink: data?.photo_link,
              isAadhaarVerified: true,
              verifyOtpCalled: true,
              showVerify: false,
            }
            setDriverDetails(updateddriverDetails)
          }
        }
      })
      .catch((error) => {
        console.log('error', error)
        toast.error(error.message)
      })
  }
  const handleAddDriver = () => {
    const newDriverNumber = nextDriverFormNumber
    setDriverForms([...driverForms, newDriverNumber])
    setDriverFormVisibility((prevVisibility) => [...prevVisibility, true])
    setDriverDetails((prevDriverDetails) => [
      ...prevDriverDetails,
      {
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        otp: '',
        workingStatus: true,
        isActive: true,
        trDate: '',
        permanentAddress: '',
        birthDate: '',
        licence_front: '',
        licence_back: '',
        aadhaar_front: '',
        aadhaar_back: '',
        police_verification: '',
      },
    ])
    setNextDriverFormNumber(newDriverNumber + 1)
  }
  const handleDriverCancelForm = (index) => {
    if (index === 0) {
      return
    }
    const newForms = driverForms.filter((_, i) => i !== index)
    const newVisibility = driverformVisibility.filter((_, i) => i !== index)
    const newDriverDetails = driverDetails.filter((_, i) => i !== index)

    setDriverForms(newForms)
    setDriverFormVisibility(newVisibility)
    setDriverDetails(newDriverDetails)
    setNextDriverFormNumber(nextDriverFormNumber - 1)
  }
  const handleDriverInputChange = (index, fieldName, value) => {
    if (fieldName === 'aadharNumber') {
      const updateddriverDetails = [...driverDetails] // Create a copy of the array
      updateddriverDetails[index] = {
        ...updateddriverDetails[index], // Spread the existing object at that index
        [fieldName]: value, // Update the field dynamically
        otpCalled: false,
        showVerify: false,
      }
      setDriverDetails(updateddriverDetails)
      setVerificationDetails((prevState) => ({
        ...prevState,
        otp: '',
      }))
      return
    }
    const updateddriverDetails = [...driverDetails] // Create a copy of the array
    updateddriverDetails[index] = {
      ...updateddriverDetails[index], // Spread the existing object at that index
      [fieldName]: value, // Update the field dynamically
    }
    setDriverDetails(updateddriverDetails) // Set the updated state
  }
  const toggleDriverFormVisibility = (index) => {
    const newVisibility = [...driverformVisibility]
    newVisibility[index] = !newVisibility[index]
    setDriverFormVisibility(newVisibility)
  }
  const handleDriverFileChange = (event, index, field) => {
    const file = event.target.files[0]
    if (file) {
      const updatedDriverDetails = [...driverDetails]
      updatedDriverDetails[index][field] = file
      setDriverDetails(updatedDriverDetails)
    }
  }

  return (
    <div className="mt-5">
      <div className="w-full text-start text-stone-500 text-sm md:text-xl font-bold">
        Register Drivers
      </div>
      <div>
        {driverForms.map((formIndex, index) => (
          <div key={formIndex} className="mt-5">
            <div className="w-full flex justify-between items-center md:text-base text-start text-stone-500 text-sm font-bold">
              <span>Driver {index + 1}</span>
              <span
                onClick={() => toggleDriverFormVisibility(index)}
                className="cursor-pointer"
              >
                <FaChevronCircleDown
                  size={20}
                  style={{
                    transform: driverformVisibility[index]
                      ? 'rotate(0deg)'
                      : 'rotate(180deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </span>
            </div>
            {driverformVisibility[index] && (
              <div className="w-full h-[1px] bg-gray-300 mt-2"></div>
            )}
            {driverformVisibility[index] && (
              <div className="mt-2">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                  <div>
                    <CustomInput
                      placeholderValue={'Enter Aadhar Number'}
                      labelValue={'Aadhar Number'}
                      required
                      disable={driverDetails[index]?.isAadhaarVerified}
                      name={`aadharNumber_${formIndex}`}
                      value={driverDetails[index]?.aadharNumber || ''}
                      formatAadharNumber
                      onChange={(text) => {
                        handleDriverInputChange(index, 'aadharNumber', text)
                      }}
                    />
                    {errors[index]?.DriverAadhaarNumber && (
                      <small className="text-red-500">
                        {errors[index]?.DriverAadhaarNumber}
                      </small>
                    )}
                    <div className="mt-3">
                      {!driverDetails[index]?.isAadhaarVerified && (
                        <SkyButton
                          label={'Send Otp'}
                          onClick={() => {
                            handleVerifyAadhaar(index)
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {driverDetails[index]?.showVerify && (
                    <div>
                      <div>
                        <CustomInput
                          labelValue={'Verify Otp'}
                          placeholderValue={'Enter Otp'}
                          required
                          formatVerifyOtp
                          name={`otp_${formIndex}`}
                          value={verificationDetails.otp || ''}
                          onChange={(text) =>
                            setVerificationDetails((prevState) => ({
                              ...prevState,
                              otp: text,
                            }))
                          }
                        />
                        <div className="mt-3">
                          <SkyButton
                            label={'Verify Otp'}
                            onClick={() => {
                              handleVerifyOtp(index)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                  <div>
                    <CustomInput
                      placeholderValue={'First Name'}
                      labelValue={'First Name'}
                      required
                      disable
                      name={`firstname_${formIndex}`}
                      value={driverDetails[index]?.firstName || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'firstName', text)
                      }
                    />
                    {errors[index]?.DriverfirstName && (
                      <small className="text-red-500">
                        {errors[index]?.DriverfirstName}
                      </small>
                    )}
                  </div>
                  <div>
                    <CustomInput
                      placeholderValue={'Middle Name'}
                      labelValue={'Middle Name'}
                      disable
                      required
                      name={`middlename_${formIndex}`}
                      value={driverDetails[index]?.middleName || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'middleName', text)
                      }
                    />
                    {errors[index]?.DrivermiddleName && (
                      <small className="text-red-500">
                        {errors[index]?.DrivermiddleName}
                      </small>
                    )}
                  </div>
                  <div>
                    <CustomInput
                      placeholderValue={'Last Name'}
                      labelValue={'Last Name'}
                      disable
                      required
                      name={`lastname_${formIndex}`}
                      value={driverDetails[index]?.lastName || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'lastName', text)
                      }
                    />
                    {errors[index]?.DriverlastName && (
                      <small className="text-red-500">
                        {errors[index]?.DriverlastName}
                      </small>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                  <div>
                    <CustomInput
                      formatMobileNumber={true}
                      placeholderValue={'Mobile Number'}
                      labelValue={'Mobile Number'}
                      inputtype={'tel'}
                      required
                      name={`mobilenumber_${formIndex}`}
                      value={driverDetails[index]?.mobileNumber || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'mobileNumber', text)
                      }
                    />
                    {errors[index]?.DrivermobileNumber && (
                      <small className="text-red-500">
                        {errors[index]?.DrivermobileNumber}
                      </small>
                    )}
                  </div>
                  <div>
                    <CustomInput
                      placeholderValue={'Email'}
                      labelValue={'Email'}
                      name={`email_${formIndex}`}
                      inputtype={'email'}
                      value={driverDetails[index]?.email || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'email', text)
                      }
                    />
                    {errors[index]?.Driveremail && (
                      <small className="text-red-500">
                        {errors[index]?.Driveremail}
                      </small>
                    )}
                  </div>
                  <div>
                    <CustomInput
                      placeholderValue={'Permanent Address'}
                      labelValue={'Permanent Address'}
                      disable
                      required
                      name={`permanentaddress_${formIndex}`}
                      value={driverDetails[index]?.permanentAddress || ''}
                      onChange={(text) =>
                        handleDriverInputChange(index, 'permanentAddress', text)
                      }
                    />
                    {errors[index]?.DriverPermanentAddress && (
                      <small className="text-red-500">
                        {errors[index]?.DriverPermanentAddress}
                      </small>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                  <div>
                    <DatePicker
                      labelValue="Birth Date"
                      disable
                      selected={driverDetails[index]?.birthDate}
                      onChange={(value) => {
                        handleDriverInputChange(index, 'birthDate', value)
                      }}
                    />
                    {errors[index]?.DriverBirthDate && (
                      <small className="text-red-500">
                        {errors[index]?.DriverBirthDate}
                      </small>
                    )}
                  </div>
                  <div>
                    <div className="flex gap-1 w-full flex-col text-start max-w-96">
                      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                        Aadharcard Front
                      </label>
                      <div>
                        <input
                          type="file"
                          accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
                          onChange={(event) =>
                            handleDriverFileChange(
                              event,
                              index,
                              'aadhaar_front'
                            )
                          }
                          className="hidden"
                          id={`aadhaar_front-${index}`}
                        />
                        <label
                          htmlFor={`aadhaar_front-${index}`}
                          className="bg-sky-500 w-20 md:w-24  px-2 py-1.5 md:text-base rounded text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                        >
                          <span>
                            <FiUpload color="#fff" />
                          </span>
                          Upload
                        </label>
                      </div>
                      {driverDetails[index]?.aadhaar_front?.name && (
                        <div className="mt-2 text-sm text-stone- justify-between flex">
                          <span>
                            {driverDetails[index]?.aadhaar_front?.name}
                          </span>
                        </div>
                      )}
                      {errors[index]?.Driveraadhaar_front && (
                        <small className="text-red-500">
                          {errors[index]?.Driveraadhaar_front}
                        </small>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="flex gap-1 w-full flex-col text-start max-w-96">
                      <label className="text-stone-700 text-xs font-semibold mt-2 md:text-base">
                        Aadharcard Back
                      </label>
                      <div>
                        <input
                          type="file"
                          accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
                          onChange={(event) =>
                            handleDriverFileChange(event, index, 'aadhaar_back')
                          }
                          className="hidden"
                          id={`aadhaar_back-${index}`}
                        />
                        <label
                          htmlFor={`aadhaar_back-${index}`}
                          className="bg-sky-500 w-20 md:w-24 md:text-base px-2 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                        >
                          <span>
                            <FiUpload color="#fff" />
                          </span>
                          Upload
                        </label>
                      </div>
                      {driverDetails[index]?.aadhaar_back?.name && (
                        <div className="mt-2 text-sm text-stone- justify-between flex">
                          <span>
                            {driverDetails[index]?.aadhaar_back?.name}
                          </span>
                        </div>
                      )}
                      {errors[index]?.Driveraadhaar_back && (
                        <small className="text-red-500">
                          {errors[index]?.Driveraadhaar_back}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
                  <div>
                    <DatePicker
                      labelValue="Tr Expiry Date"
                      selected={driverDetails[index]?.trDate}
                      onChange={(value) => {
                        handleDriverInputChange(index, 'trDate', value)
                      }}
                      minDate={new Date().toISOString().split('T')[0]}
                      maxDate={(() => {
                        const maxDate = new Date()
                        maxDate.setFullYear(maxDate.getFullYear() + 3) // Set maxDate to 1 year from today
                        return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                      })()}
                    />
                    {errors[index]?.DrivertrExpiryDate && (
                      <small className="text-red-500">
                        {errors[index]?.DrivertrExpiryDate}
                      </small>
                    )}
                  </div>
                  <div>
                    <div className="flex gap-1 w-full flex-col text-start max-w-96">
                      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                        Driving Licence Front
                      </label>
                      <div>
                        <input
                          type="file"
                          accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
                          onChange={(event) =>
                            handleDriverFileChange(
                              event,
                              index,
                              'licence_front'
                            )
                          }
                          className="hidden"
                          id={`licence_front-${index}`}
                        />
                        <label
                          htmlFor={`licence_front-${index}`}
                          className="bg-sky-500 w-20 md:w-24 md:text-base px-2 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                        >
                          <span>
                            <FiUpload color="#fff" />
                          </span>
                          Upload
                        </label>
                      </div>
                      {driverDetails[index]?.licence_front?.name && (
                        <div className="mt-2 text-sm text-stone- justify-between flex">
                          <span>
                            {driverDetails[index]?.licence_front?.name}
                          </span>
                        </div>
                      )}
                      {errors[index]?.Driverlicence_front && (
                        <small className="text-red-500">
                          {errors[index]?.Driverlicence_front}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-1 w-full flex-col text-start max-w-96">
                    <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                      Driving Licence Back
                    </label>
                    <div>
                      <input
                        type="file"
                        accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
                        onChange={(event) =>
                          handleDriverFileChange(event, index, 'licence_back')
                        }
                        className="hidden"
                        id={`licence_back-${index}`}
                      />
                      <label
                        htmlFor={`licence_back-${index}`}
                        className="bg-sky-500 w-20 md:w-24 md:text-base px-2 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                      >
                        <span>
                          <FiUpload color="#fff" />
                        </span>
                        Upload
                      </label>
                    </div>
                    {driverDetails[index]?.licence_back?.name && (
                      <div className="mt-2 text-sm text-stone- justify-between flex">
                        <span>{driverDetails[index]?.licence_back?.name}</span>
                      </div>
                    )}
                    {errors[index]?.Driverlicence_back && (
                      <small className="text-red-500">
                        {errors[index]?.Driverlicence_back}
                      </small>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                  <div className="flex gap-1 w-full flex-col text-start max-w-96">
                    <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
                      Police Verification
                    </label>
                    <div>
                      <input
                        type="file"
                        accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
                        onChange={(event) =>
                          handleDriverFileChange(
                            event,
                            index,
                            'police_verification'
                          )
                        }
                        className="hidden"
                        id={`police_verification-${index}`}
                      />
                      <label
                        htmlFor={`police_verification-${index}`}
                        className="bg-sky-500 w-20 md:w-24 md:text-base px-2 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white cursor-pointer"
                      >
                        <span>
                          <FiUpload color="#fff" />
                        </span>
                        Upload
                      </label>
                    </div>
                    {driverDetails[index]?.police_verification?.name && (
                      <div className="mt-2 text-sm text-stone- justify-between flex">
                        <span>
                          {driverDetails[index]?.police_verification?.name}
                        </span>
                      </div>
                    )}
                    {errors[index]?.Driverpolice_verification && (
                      <small className="text-red-500">
                        {errors[index]?.Driverpolice_verification}
                      </small>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2"></div>
                <div>
                  <button
                    onClick={() => handleDriverCancelForm(index)}
                    className="bg-red-500 mt-5 md:text-base px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white"
                  >
                    Remove
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className="mt-5 flex justify-start gap-4">
          <button
            onClick={handleAddDriver}
            className="bg-sky-500 px-4 py-1.5 md:text-base rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
          >
            <RiAddFill size={20} />
            Add Drivers
          </button>
        </div>
      </div>
    </div>
  )
}

export default FleetDriverReg
